import { mapGetters,mapActions } from 'vuex'

export default {
  data () {
    return {

    }
  },
  computed: {
    // companyId 商户ID ｜ gasId 油站ID  ｜  account 当前生效的账户类型
    ...mapGetters(['account_code'])
  },
  methods: {
    // 设置生效的账户类型，存放到vuex
    ...mapActions('finance', {'dispatchAccountCode':'setAccountType'}),
  }
}
